module.exports = __webpack_public_path__ + "img/categories_bg.bd8f35b6.svg";